import Vue from "vue";
import Vuex from "vuex";
import { loader } from "./modules/loader";
import { snackbar } from "./modules/snackbar";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    loader,
    snackbar
  }
});
